import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import PurchaseList from "../../components/screen/purchaseOnlinePbf/PurchaseList";

const PurchasePbfPage = () => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          <PurchaseList />
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gray"}
      noPadding={true}
    />
  );
};

export default HOC(PurchasePbfPage);
